import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloCarac } from '@/models/alo/AloCarac'

export default {
  getCarac(filterCarac:{u?:number,r?:number,f?:number,s?:string}): AxiosPromise<AlrContainer<Array<AloCarac>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/carac`, 
      method: 'GET',
      params:filterCarac,
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloCarac>>
      }]
    })
  }
}